function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-89,449.4h-40.8l-12,21.6H-77L-89,449.4z M-144.2,440.6l-20.8-34.4h-24l32,56L-144.2,440.6z M-29,405.4h-24.8l-20,34.4 l12.8,21.6L-29,405.4z M-129,431.8h40.8l20-35.2l-20-35.2H-129l-20,35.2L-129,431.8z M-97,375.8l12,20.8l-12,20.8h-24l-12-20.8 l12-20.8H-97z M-189,387.8h24l20-34.4l-12-21.6L-189,387.8z M-73.8,353.4l20,34.4H-29l-32-56L-73.8,353.4z M-129,344.6h40.8l12-21.6 H-141L-129,344.6z"
});

var SvgSwrpgThreat = function SvgSwrpgThreat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgThreat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-threat.c526091d.svg";
export { ForwardRef as ReactComponent };